import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { permanentRedirect } from '../helpers';

export default function EditorRedirect() {
  const { hash, search } = useLocation();
  const navigate = useNavigate();
  const hashParams = useMemo(() => new URLSearchParams(hash?.substring(1)), [hash]);
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const redirect = permanentRedirect(navigate);

  useEffect(() => {
    // check and see if either the query string or hash frag contains `id` or `fid`
    // and redirect accordingly
    const id = hashParams.get('id') ?? searchParams.get('id');
    const fid = hashParams.get('fid') ?? searchParams.get('fid');
    // remove these from the query string after extracting them for redireciton
    searchParams.delete('id');
    searchParams.delete('fid');

    const query = searchParams.toString();

    if (!!id) {
      redirect(`/forms/${id}${query ? `?${query}` : ''}`);
      return;
    }

    if (!!fid) {
      redirect(`/forms/new?templateId=${fid}${query ? `&${query}` : ''}`);
      return;
    }

    redirect('/forms');
  }, [hashParams, searchParams]);

  return null;
}
